import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { environment } from 'src/environments/environment';
import { GeneralResponse } from '../../data-models/shared.data-models';
import { LoginResultDto } from '../../data-models/identity.data.models';
import {
  InvitationActivateDto,
  InvitationDetailsDto,
  InvitationLinkResponseDto,
  InvitationSendOtpResponseDto,
} from '../../data-models/invitation-registration.data.models';

@Injectable({ providedIn: 'root' })
export class InvitationRegistrationDataService {
  private controllerUrl = 'InvitationRegistration/';

  constructor(
    private baseApi: BaseApiService<any>,
    private notificationService: NotificationService
  ) {}

  /**
   * Validates the invitation link status.
   * Body: { token }
   */
  checkLink(token: string): Observable<InvitationLinkResponseDto> {
    return this.baseApi.Post(`${this.controllerUrl}Link`, { token });
  }

  /**
   * Sends the 6-digit OTP code to the investor's mobile number.
   * Body: { token }
   */
  sendOtp(token: string): Observable<GeneralResponse<InvitationSendOtpResponseDto>> {
    return this.baseApi.Post(`${this.controllerUrl}SendOtp`, { token }).pipe(
      tap((res: any) => {
        const resData = res?.data || res;
        const otp =
          resData?.DevOtp ||
          resData?.devOtp ||
          res?.DevOtp ||
          res?.devOtp ||
          resData?.Otp ||
          resData?.otp ||
          res?.Otp ||
          res?.otp;

        const isNonProduction =
          !environment.production && environment.name !== 'production';

        if (isNonProduction && otp) {
          this.notificationService.success(`OTP: ${otp}`);
        }
      })
    );
  }

  /**
   * Verifies the 6-digit OTP code.
   * Body: { token, otp }
   */
  verifyOtp(token: string, otp: string): Observable<GeneralResponse<any>> {
    return this.baseApi.Post(`${this.controllerUrl}VerifyOtp`, { token, otp });
  }

  /**
   * Retrieves pre-filled details (National ID, Email, Birth Date, Phone Number)
   * and password rules.
   * Body: { token }
   */
  getDetails(token: string): Observable<GeneralResponse<InvitationDetailsDto>> {
    return this.baseApi.Post(`${this.controllerUrl}Details`, { token });
  }

  /**
   * Activates the investor's account.
   * Body: { token, password, acceptTerms: true }
   * Returns sign-in data (LoginResultDto).
   */
  activate(body: InvitationActivateDto): Observable<GeneralResponse<LoginResultDto>> {
    return this.baseApi.Post(`${this.controllerUrl}Activate`, body);
  }
}
